import s from './index.module.css';
import style from '../../index.module.css';
import { Input, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';

export const NumberOfAttempts = ({ data, edit }) => {
  const handleChange = (e) => {
    const value = e.target.value;

    if (value === '' || Number(value) >= 1) {
      edit((prev) => ({
        ...prev,
        number_of_attempts: value === '' ? '' : Number(value),
      }));
    }
  };

  const handleBlur = () => {
    edit((prev) => ({
      ...prev,
      number_of_attempts: prev.number_of_attempts === '' ? 2 : prev.number_of_attempts,
    }));
  };

  return (
    <div className={s.wrapper}>
      <div>
        <span className={style.heading}>Кол-во попыток: </span>
        <Tooltip title="Если учащийся не верно сделает задание, то ему система напишет об этом, покажет подсказку и у него будет возможность сразу же перерешать это задание ещё раз. Данное поле контролирует то, сколько раз учащийся может перерешать конкретное задание. Значение 1 – человек не может перерешать задание, 2 – может перерешать его один раз">
          <InfoCircleOutlined className={s.infoTooltip} />
        </Tooltip>
      </div>
      <Input
        onWheel={(e) => e.target.blur()}
        type="number"
        className={classNames(style.inputNew, s.input)}
        value={data?.number_of_attempts ?? ''}
        onChange={handleChange}
        onBlur={handleBlur}
        min="1"
      />
    </div>
  );
};
